import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import ArticleSection from './components/ArticleSection';
import FeatureSection from './components/FeatureSection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEO
        title="首页"
        description="黄瓜视频是一款备受用户喜爱的短视频平台，提供海量高清视频内容，支持免费在线观看与下载。汇聚多元化创作者，覆盖娱乐、生活、美食、科技等丰富类目。"
        keywords="黄瓜视频,黄瓜视频官方下载,黄瓜视频app,黄瓜视频在线观看,黄瓜视频最新版本,黄瓜视频高清播放,黄瓜短视频平台"
        canonicalUrl="https://huangguavideo.com/"
      />
      <SchemaOrg type="Organization" data={{
        name: '黄瓜视频',
        url: 'https://huangguavideo.com',
        description: '黄瓜视频 - 高清短视频平台，提供海量高清视频内容，支持免费在线观看与下载',
        sameAs: ['https://weibo.com/huangguavideo', 'https://www.douyin.com/user/huangguavideo'],
      }} />
      <SchemaOrg type="WebSite" data={{
        name: '黄瓜视频',
        url: 'https://huangguavideo.com',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://huangguavideo.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '黄瓜视频 - 高清短视频平台官方入口',
        description: '黄瓜视频是一款备受用户喜爱的短视频平台，提供海量高清视频内容',
        url: 'https://huangguavideo.com',
        isPartOf: { '@type': 'WebSite', name: '黄瓜视频', url: 'https://huangguavideo.com' },
      }} />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <StatsSection />
        <ArticleSection />
        <FeatureSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}